module.exports = __webpack_public_path__ + "4f23e1b9a85756a349b4d67b0f0d7bb2.png";